import { render, staticRenderFns } from "./DocumentQueue.vue?vue&type=template&id=79bc12cc&"
import script from "./DocumentQueue.vue?vue&type=script&lang=js&"
export * from "./DocumentQueue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports